import * as React from 'react';
import PlayerPreviousOutlined from './player-previous-outlined';
import PlayerPreviousFilled from './player-previous-filled';
import type { IconCombinedProps } from './types';
const PlayerPreviousCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <PlayerPreviousFilled ref={ref} {...rest} />;
  }
  return <PlayerPreviousOutlined ref={ref} {...rest} />;
});
export default PlayerPreviousCombined;